import {
  faExclamationTriangle,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import Icon from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import LastUpdatedText from "components/shared/LastUpdated/LastUpdatedText/LastUpdatedText";
import { RequestStatus } from "hooks/useRequest";
import React from "react";
import featureFlags from "utils/featureFlags";

import {
  Container,
  RefreshErrorContainer,
  RefreshButton,
  RefreshButtonText,
  RefreshButtonOld,
  RefreshButtonTextOld,
} from "./style";

interface Props {
  lastRefreshedDate?: Date;
  requestStatus: RequestStatus;
  triggerDataRefresh: () => Promise<void>;
}

/**
 * Displays the elapsed time since the last data refresh
 * and provides a refresh button to trigger an update.
 *
 * @param {Date} [lastRefreshedDate] - The timestamp of the last data refresh (optional).
 * @param {RequestStatus} requestStatus - The current status of the data request.
 * @param {() => Promise<void>} triggerDataRefresh - A function to manually trigger a data refresh.
 */
const LastUpdatedWithRefresh: React.FC<Props> = ({
  lastRefreshedDate,
  requestStatus,
  triggerDataRefresh,
}) => {
  const Button = featureFlags.rebrand ? RefreshButton : RefreshButtonOld;
  const ButtonText = featureFlags.rebrand
    ? RefreshButtonText
    : RefreshButtonTextOld;

  return (
    <Container aria-live="polite">
      <Button
        onClick={triggerDataRefresh}
        disabled={requestStatus === RequestStatus.IN_PROGRESS}
      >
        <ButtonText>Refresh</ButtonText>
        {featureFlags.rebrand ? (
          <span className="icon">#</span>
        ) : (
          <Icon iconName={faRefresh} size={IconSize.mediumSmall} />
        )}
      </Button>
      <LastUpdatedText
        lastRefreshedDate={lastRefreshedDate}
        isLoading={requestStatus === RequestStatus.IN_PROGRESS}
      />
      {requestStatus === RequestStatus.ERRORED && (
        <RefreshErrorContainer>
          <Icon iconName={faExclamationTriangle} size={IconSize.mediumSmall} />
          <p aria-live="polite">
            Page failed to auto-refresh, please click on refresh
          </p>
        </RefreshErrorContainer>
      )}
    </Container>
  );
};

export default LastUpdatedWithRefresh;
